import { refCode } from "./attribution";

export const BOOKING_URL = "https://hotels.cloudbeds.com/reservation/PAfrmJ";
export const WHATSAPP_NUMBER = "5521970777955";
export const waUrl = (msg) =>
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(`${msg} [ref: ${refCode()}]`)}`;
export const MAPS_URL =
    "https://maps.google.com/?q=Matianellu+Hostel,+R.+Em%C3%ADlio+Berla,+41+-+Copacabana,+Rio+de+Janeiro";
export const MAP_EMBED =
    "https://www.google.com/maps?q=Matianellu%20Hostel,%20R.%20Em%C3%ADlio%20Berla%2041,%20Copacabana,%20Rio%20de%20Janeiro&output=embed";
export const SOCIAL = {
    instagram: "https://www.instagram.com/matianelluhostel/?hl=es",
    facebook: "https://www.facebook.com/profile.php?id=100083359661342&locale=pt_BR",
};

export const IMG = {
    hero: "/images/hero.jpg",
    exterior: "/images/real_praia.webp",
    room: "/images/real_cuarto.webp",
    interior: "/images/real_entrada.webp",
    lounge: "/images/real_rua.webp",
    kitchen: "/images/real_gente.webp",
    dorms: "/images/real_cuartos2.webp",
    dining: "/images/real_comedor.webp",
    bar: "/images/real_bar.webp",
    tvRoom: "/images/real_lounge.webp",
    guestsBar: "/images/real_gente2.webp",
};
